import React from "react";
import { IconName } from "halifax";
import { FiatPrice, RewardsAccount, RewardsPrice } from "redmond";
import { formatCurrency, formatRewards } from "../../state/utils";

const getEarnMessage = (
  earn: RewardsPrice,
  earnRewardsAccount: RewardsAccount
) => (
  <>
    <strong>Earn {formatRewards(earn)}</strong> on this booking with{" "}
    {earnRewardsAccount.productDisplayName}
  </>
);

const getDiscountMessage = (discount: FiatPrice) => (
  <>
    <strong>Save {formatCurrency(discount)}</strong> by booking this hotel and
    flight together
  </>
);

export const LOADING_MESSAGES: (
  discount?: FiatPrice,
  earn?: RewardsPrice,
  earnRewardsAccount?: RewardsAccount
) => { message: JSX.Element | string; icon: IconName }[] = (
  discount,
  earn,
  earnRewardsAccount
) => [
  ...(!!earn?.value && !!earnRewardsAccount
    ? [
        {
          message: getEarnMessage(earn, earnRewardsAccount),
          icon: IconName.GiftWithBoardingPass,
        },
      ]
    : []),
  ...(discount?.value
    ? [{ message: getDiscountMessage(discount), icon: IconName.CashBills }]
    : []),
  { message: "Checking availability", icon: IconName.TravelSuitcase },
  { message: "This may take a few seconds", icon: IconName.Hourglass },
];
